import { EMPTY_STRING } from '@shared/models/strings.constants';
import { abbrevNumber } from '@miq/utils';
import { Icon } from 'leaflet';

/* tslint:disable */
const bubble = `  <ellipse fill="#ff0000" stroke="#f2f2f2" stroke-width="25.5" cx="504.5" cy="74.9375" id="svg_2" rx="61" ry="60.5"/>`;
const blueBg = '#01a2cb';
const blueShadowBg = '#6ec5db';
const hoveredBg = '#D00287';
const headquarterBg = '#FFA500'; // this color will change

export const buildSvgIcon = ({ text, pending = false, hovered = false, isHeadQuarter = false, isShadow = false }) => {
  let bgColor = '';
  if (hovered) {
    bgColor = hoveredBg;
  } else if (isHeadQuarter) {
    bgColor = headquarterBg;
  } else if (isShadow) {
    bgColor = blueShadowBg;
  } else {
    bgColor = blueBg;
  }
  return `<svg width="580" height="400" xmlns="http://www.w3.org/2000/svg">
  <g>
    <g id="canvasGrid" display="none">
      <rect id="svg_5" width="100%" height="100%" x="0" y="0" stroke-width="0" fill="url(#gridpattern)"/>
    </g>
  </g>
  <g>
    <rect stroke="#f2f2f2" fill="${bgColor}" stroke-width="25.5" x="34" y="34.43749" width="510.00001" height="247.00001" id="svg_1" rx="52"/>
    ${pending ? bubble : ''}
    <path transform="rotate(180 289.07196044921875,334.67706298828125) " fill="#f2f2f2" stroke-width="25.5" d="m258.66152,356.46068l30.41045,-53.74424l33.05522,63.92127l-66.11044,0l2.64476,-10.17703l0.00001,0z" id="svg_3" stroke="#f2f2f2"/>
    <text fill="#ffffff" stroke-width="0" stroke-opacity="null" x="166.52846" y="160.32259" id="svg_6" font-size="24" font-family="FuturaBT-Bold" text-anchor="middle"
      xml:space="preserve" transform="matrix(4.901727655036886,0,0,4.376046404051863,-526.2432235501507,-510.4202035032642)"
      stroke="#01a2cb" font-weight="bold">${text}</text>
    <path transform="rotate(179.77877807617188 289.07196044921875,283.67706298828125) "
      fill="${bgColor}" stroke-width="25.5" d="m258.66152,305.46068l30.41045,-53.74424l33.05522,63.92127l-66.11044,0l2.64477,-10.17703z" id="svg_4"
      stroke="${bgColor}"/>
   </g>
   <g>
    <rect fill="none" id="canvas_background" height="402" width="582" y="-1" x="-1"/>
  </g>
</svg>`;
};
/* tslint:enable */

export const reportIcon = ({
  text,
  pending: _pending = false,
  hovered: _hovered = false,
  isHeadQuarter: _isHeadQuarter = false,
  isShadow: _isShadow = false,
  paddingLeft,
}) => `<svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px"
y="0px" viewBox="0 0 35 41" style="enable-background:new 0 0 35 41;" xml:space="preserve">
<style type="text/css">
.st0{fill:#00A657;}
.st1{fill:none;stroke:#FFFFFF;stroke-width:2;stroke-miterlimit:10;}
.st2{fill:#FFFFFF;font-family:'FuturaBT-Bold', sans-serif;font-size:12px;}
</style>
<g>
 <image style="overflow:visible;opacity:0.25;enable-background:new;" width="54" height="58"
          xlink:href="33D6A4345D23B4AC.png"
   />
   <path class="st0"
         d="M39.7,22.9c0,11.2-13,16.9-13,16.9s-13-5.6-13-16.9C13.5,15.9,19,10,26,9.8h0.7c7-0.1,12.9,5.4,13,12.5V22.9z"
   />
   <path class="st1"
         d="M40,23.1C40,34.3,27,40,27,40s-13-5.6-13-16.9c-0.2-7,5.3-12.9,12.3-13.1H27c7-0.1,12.9,5.4,13,12.5V23.1z"
   />
   <text transform="matrix(1 0 0 1 ${paddingLeft} 28.5198)" class="st2">${text}</text>
</g>
</svg>

`;

export const reportSingleIcon = ({
  text: _text,
  pending: _pending = false,
  hovered: _hovered = false,
  isHeadQuarter: _isHeadQuarter = false,
  isShadow: _isShadow = false,
  paddingLeft: _paddingLeft,
}) => `<svg xmlns="http://www.w3.org/2000/svg" width="34" height="38" viewBox="0 0 34 38" fill="none">
<g filter="url(#filter0_d)">
<mask id="path-1-inside-1" fill="white">
<path fill-rule="evenodd" clip-rule="evenodd" d="M17 30C17 30 30 24.375 30 13.1514C30 4.6875 23.5 0 17 0C10.5 0 4 4.6875 4 13.1514C4 24.375 17 30 17 30ZM17 11C15.8954 11 15 11.8954 15 13C15 14.1046 15.8954 15 17 15C18.1046 15 19 14.1046 19 13C19 11.8954 18.1046 11 17 11Z"/>
</mask>
<path fill-rule="evenodd" clip-rule="evenodd" d="M17 30C17 30 30 24.375 30 13.1514C30 4.6875 23.5 0 17 0C10.5 0 4 4.6875 4 13.1514C4 24.375 17 30 17 30ZM17 11C15.8954 11 15 11.8954 15 13C15 14.1046 15.8954 15 17 15C18.1046 15 19 14.1046 19 13C19 11.8954 18.1046 11 17 11Z" fill="#00A657"/>
<path d="M17 30L16.2058 31.8355L17 32.1792L17.7942 31.8355L17 30ZM28 13.1514C28 17.9314 25.2367 21.6398 22.1921 24.2715C20.687 25.5724 19.1729 26.5554 18.0322 27.2131C17.4641 27.5407 16.9943 27.7843 16.6723 27.9435C16.5114 28.023 16.3879 28.0812 16.308 28.1181C16.268 28.1366 16.239 28.1496 16.2217 28.1574C16.2131 28.1612 16.2073 28.1638 16.2046 28.1649C16.2033 28.1655 16.2027 28.1658 16.2029 28.1657C16.203 28.1657 16.2033 28.1655 16.2038 28.1653C16.204 28.1652 16.2045 28.165 16.2046 28.165C16.2052 28.1647 16.2058 28.1645 17 30C17.7942 31.8355 17.7949 31.8352 17.7957 31.8349C17.796 31.8348 17.7968 31.8344 17.7974 31.8341C17.7987 31.8336 17.8002 31.833 17.8018 31.8322C17.8052 31.8308 17.8093 31.829 17.8142 31.8268C17.824 31.8225 17.8369 31.8168 17.8529 31.8097C17.8848 31.7954 17.9287 31.7756 17.984 31.7501C18.0945 31.6991 18.2503 31.6255 18.4449 31.5293C18.8339 31.337 19.3797 31.0535 20.0303 30.6784C21.3271 29.9306 23.063 28.8059 24.8079 27.2976C28.2633 24.3109 32 19.595 32 13.1514H28ZM17 2C22.5668 2 28 5.95595 28 13.1514H32C32 3.41905 24.4332 -2 17 -2V2ZM6 13.1514C6 5.95595 11.4332 2 17 2V-2C9.56676 -2 2 3.41905 2 13.1514H6ZM17 30C17.7942 28.1645 17.7948 28.1647 17.7954 28.165C17.7955 28.165 17.796 28.1652 17.7962 28.1653C17.7967 28.1655 17.797 28.1657 17.7971 28.1657C17.7973 28.1658 17.7967 28.1655 17.7954 28.1649C17.7927 28.1638 17.7869 28.1612 17.7783 28.1574C17.761 28.1496 17.732 28.1366 17.692 28.1181C17.6121 28.0812 17.4886 28.023 17.3277 27.9435C17.0057 27.7843 16.5359 27.5407 15.9678 27.2131C14.8271 26.5554 13.313 25.5724 11.8079 24.2715C8.76328 21.6398 6 17.9314 6 13.1514H2C2 19.595 5.73672 24.3109 9.19212 27.2976C10.937 28.8059 12.6729 29.9306 13.9697 30.6784C14.6203 31.0535 15.1661 31.337 15.5551 31.5293C15.7497 31.6255 15.9055 31.6991 16.016 31.7501C16.0713 31.7756 16.1152 31.7954 16.1471 31.8097C16.1631 31.8168 16.176 31.8225 16.1858 31.8268C16.1907 31.829 16.1948 31.8308 16.1982 31.8322C16.1998 31.833 16.2013 31.8336 16.2026 31.8341C16.2032 31.8344 16.204 31.8348 16.2043 31.8349C16.2051 31.8352 16.2058 31.8355 17 30ZM17 13V9C14.7909 9 13 10.7909 13 13H17ZM17 13H13C13 15.2091 14.7909 17 17 17V13ZM17 13V17C19.2091 17 21 15.2091 21 13H17ZM17 13H21C21 10.7909 19.2091 9 17 9V13Z" fill="white" mask="url(#path-1-inside-1)"/>
</g>
<defs>
<filter id="filter0_d" x="0" y="0" width="34" height="38" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
<feFlood flood-opacity="0" result="BackgroundImageFix"/>
<feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"/>
<feOffset dy="4"/>
<feGaussianBlur stdDeviation="2"/>
<feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"/>
<feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow"/>
<feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow" result="shape"/>
</filter>
</defs>
</svg>`;

export type IconGenerator = (iconOpts: {}) => string;

export enum MapIcon {
  Default = 'default',
  ReportIcon = 'reportIcon',
  ReportSingleIcon = 'reportSingleIcon',
}

export enum PinPadding {
  Small = 18,
  Medium = 21,
  Large = 24.2,
}

export const iconMap: { [key: string]: IconGenerator } = {
  [MapIcon.Default]: buildSvgIcon,
  [MapIcon.ReportIcon]: reportIcon,
  [MapIcon.ReportSingleIcon]: reportSingleIcon,
};

export const svgIconMaker = (svgData, options?) => {
  const reportIconToUse = svgData.iconToUse;
  const iconToUse = reportIconToUse != null ? iconMap[svgData.iconToUse] : iconMap[MapIcon.ReportSingleIcon];
  const fn = iconToUse(svgData);
  return svgIconFactory(fn, { ...options });
};

const svgIconFactory = (svgData, { width = 58, height = 40 }) =>
  new Icon({
    iconUrl: `data:image/svg+xml;charset=UTF-8,${encodeURIComponent(svgData)}`,
    iconSize: [width, height],
  });

export const toggleIcon = marker => {
  const {
    options: { value, pending, hovered, isHeadQuarter },
  } = marker;
  const iconOpts = {
    text: !!+value ? abbrevNumber(value) : EMPTY_STRING,
    pending: !!pending,
    hovered: !hovered,
    isHeadQuarter,
  };
  const icon = svgIconMaker(iconOpts, value == null || value === '' ? { width: 30, height: 40 } : null);
  marker.setIcon(icon);
  marker.options.hovered = !hovered;
};
